import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import animateScrollTo from 'animated-scroll-to';
import PartnerItem from './PartnerItem';
// import Button from '../../../common/button/Button';
// import Banner from '../../../common/Banner/Banner';
import Spinner from '../../../common/Spinner/Spinner';

// Banners
// const multiBannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-partner-multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };

class PartnersComponent extends Component {
    componentDidMount() {
        animateScrollTo(0, { speed: 700 });

        this.props.getPartnersDataIfNeeded();
    }

    _mapPartners = function _mapPartners() {
        return this.props.partnersData.map((partner) =>
        // const tempIndex = index + 1;

        // if (tempIndex % 12 === 0 && index !== 0) {
        //     return ([
        //         <PartnerItem
        //             key={partner.name}
        //             title={partner.name}
        //             image={`https://a1media.antena1.com.br/image/parceiros/${partner.image}`}
        //             description={partner.description}
        //         />,
        //     ]);
        // }
            // eslint-disable-next-line implicit-arrow-linebreak
            (
                <PartnerItem
                    key={partner.name}
                    title={partner.name}
                    image={`https://a1media.antena1.com.br/image/parceiros/${partner.image}`}
                    description={partner.description}
                />
            ),
        );
    }

    render() {
        return (
            <section className="sectionPartners">
                <header>
                    <h1>Parceiros</h1>
                    <p className="pageSubtitle">Conheça as marcas que nos apoiam</p>
                </header>
                <div className="containerOfPartners tw-grid lg:tw-grid-cols-4 md:tw-grid-cols-3 sm:tw-grid-cols-2 tw-grid-cols-1 tw-gap-2 lg:tw-gap-10">
                    {!this.props.isLoading && this.props.partnersData.length > 0 ?
                        this._mapPartners()
                        : <Spinner />}
                </div>
                {/* <div className="conteinerBtn">
                    <Button title="Ir para a página Anuncie Conosco" className="btnAnuncie" to="/anuncie-conosco">Anuncie conosco</Button>
                </div> */}
            </section>
        );
    }
}

PartnersComponent.propTypes = exact({
    partnersData: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        image: PropTypes.string,
        description: PropTypes.string,
    })).isRequired,
    isLoading: PropTypes.bool.isRequired,
    getPartnersDataIfNeeded: PropTypes.func.isRequired,
});

export default PartnersComponent;
